(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsSharedAgendaController', [AgendaSettingsSharedAgendaControllerFn]);

    /* controller for main shared agendas */
    function AgendaSettingsSharedAgendaControllerFn() {
        var vm = this;

        activate();

        /* activation work */
        function activate() {
        }
    }
})();
